
import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-20 h-20',
    xl: 'w-32 h-32',
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]} ${className}`}>
      <div className="absolute inset-0 bg-brand-green/20 blur-xl rounded-full" />
      <svg 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 drop-shadow-[0_0_8px_rgba(0,230,118,0.6)]"
      >
        <g stroke="#00E676" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
          <line x1="25" y1="90" x2="75" y2="90" strokeWidth="8" />
          <path d="M 25 75 L 18 30 L 38 50 L 50 12 L 62 50 L 82 30 L 75 75 Z" strokeWidth="6"/>
          <circle cx="37" cy="55" r="5" strokeWidth="4" />
          <circle cx="63" cy="55" r="5" strokeWidth="4" />
          <path d="M 35 70 L 65 70" strokeWidth="4" />
        </g>
        <circle cx="46" cy="62" r="1.5" fill="#00E676" />
        <circle cx="54" cy="62" r="1.5" fill="#00E676" />
      </svg>
    </div>
  );
};
